import React, { useState, useEffect } from 'react';

import themePropTypes from 'core/utils/prop-types/theme';

import withTheme from 'core/hocs/withTheme';
import withThemeSwitcher from 'core/hocs/withThemeSwitcher';

import Button from 'core/components/Button';

import styles from './index.styl';


function CookiesBanner(props) {
  const {
    theme: {
      controls: {
        cookiesBanner: cookiesBannerAtoms,
      },
    },
  } = props;

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const cookiesAccepted = localStorage.getItem('cookiesAccepted');
    if (!cookiesAccepted) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className={styles.cookiesBanner}>
      <style jsx>{`
        .${styles.cookiesBanner}
          background ${cookiesBannerAtoms.background}
          bottom ${cookiesBannerAtoms.bannerOffsetBottom}

        .text
        .${styles.link}
          font ${cookiesBannerAtoms.text.font}
          color ${cookiesBannerAtoms.text.color}

        .button-text
          font ${cookiesBannerAtoms.button.btnText}
      `}</style>
      <div className='text'>
        На сайте используются cookies. Продолжая использовать сайт, вы
        принимаете&nbsp;
        <a
          href='/legal/terms-of-use'
          className={styles.link}
        >
          условия
        </a>
      </div>
      <Button
        onClick={handleAccept}
        minWidth={42}
        height='30px'
        size={cookiesBannerAtoms.button.btnSize}
        type={cookiesBannerAtoms.button.btnType}
        radius={cookiesBannerAtoms.button.btnRadius}
      >
        <span className='button-text'>Ок</span>
      </Button>
    </div>
  );
}
CookiesBanner.propTypes = {
  /** @ignore */
  theme: themePropTypes(`
    {
      controls: {
        cookiesBanner: {
          background,
          bannerOffsetBottom,

          text: {
            font,
            color,
          },

          button: {
            btnSize,
            btnType,
            btnRadius,
            btnText,
          },
        },
      }
    }
  `),
};

const CookiesBannerWithHOCs = withThemeSwitcher('light')(withTheme(CookiesBanner));

CookiesBannerWithHOCs.displayName = 'CookiesBanner';

export { CookiesBanner as StorybookComponent };
export default CookiesBannerWithHOCs;
